
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyQuoteBar from '../../components/feature/StickyQuoteBar';
import HeroSection from '../../components/home/HeroSection';
import DSCRCalculator from '../../components/home/DSCRCalculator';
import ServiceCards from '../../components/home/ServiceCards';
import WhyChooseUs from '../../components/home/WhyChooseUs';
import TestimonialsSlider from '../../components/home/TestimonialsSlider';
import CTASection from '../../components/home/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white dark:bg-finance-dark">
      <Navbar />
      <main>
        <HeroSection />
        <DSCRCalculator />
        <ServiceCards />
        <WhyChooseUs />
        <TestimonialsSlider />
        <CTASection />
      </main>
      <Footer />
      <StickyQuoteBar />
    </div>
  );
}